<template lang="pug">
  .builds
    FiltrableTable
      template(v-slot="{ bus }")
        build-list-table(
          :bus="bus"
          :builds="builds"
          :constructorNames="constructorNames"
          :orderStatuses="orderStatuses"
        )
</template>

<script>
import FiltrableTable from '@/components/FilterableTable/FilterableTable.vue';
import BuildListTable from './BuildListTable.vue';

export default {
  props: {
    constructorNames: {
      type: Array,
      required: true,
      default: () => []
    },

    orderStatuses: {
      type: Array,
      required: true,
      default: () => []
    },

    builds: {
      type: Array,
      required: true
    }
  },

  components: {
    FiltrableTable,
    BuildListTable
  }
};
</script>
